<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>

<template>
  <div>
    <h2>Posiciones del Ejército de Oriente, febrero de 1862</h2>
    <img @click="imageClicked(0)" src="galerias/sala2/S2_G1.jpg" class="mainphoto"/><br>
    <p>El Ejército de Oriente estaba conformado por un General en Jefe, cargo asignado a Ignacio Zaragoza, con un cuerpo de 9 generales, 162 jefes, 777 oficiales, 8,095 personas de tropa, 1,482 caballos y 810 acémilas (mulas para llevar carga), distribuidos en varios puntos estratégicos de Veracruz, principalmente, con la intención de salvaguardar el territorio nacional.</p>
    <p>Sus efectivos estaban distribuidos de la siguiente forma:</p>
    <p>
        1a. División: Comandante Gral. Ignacio de la Llave con las Brigadas 1a. a cargo del Coronel José Ma. Mora; 2a. Macario Prieto y 3a. Coronel Mariano Rojo. Cubrían la línea de Xalapa.<br>
        2a. División: Comandante Gral. Francisco Lamadrid, con dos Brigadas a las órdenes de los Coroneles Pedro Rioseco y Mariano Camacho. Cubrían hasta la población de la Soledad.<br>
        3a. División: Comandante Gral. Ignacio Mejía con 2 Brigadas al mando del Coronel Antonio Ramírez y del Gral. Porfirio Díaz. De Potrero a Camarón. <br>
        La Brigada México a las órdenes del Gral. Ignacio Echegaray, guarnecía Cotaxtla.<br>
        La Brigada de Caballería estaba al mando del Gral. Antonio Álvarez, acantonada en Chalchicomula. <br>
        Sección Gálvez, estaba en Chiquihuite, comandada por José María Álvarez.<br>
        Lamentablemente estos efectivos se diezmaron con la explosión en Chalchicomula, y en las bajas de los primeros encuentros.<br>
    </p>
    <h5>Ver más:</h5>
    <p>Aquí puedes ver la fotografía de un soldado de la época:<a target="_blank" href="http://mediateca.inah.gob.mx/repositorio/islandora/object/fotografia%3A6902">mediateca.inah.gob.mx</a></p>
  </div>
</template>

<script>
export default {
  name: "s21g01",
  data() {
    return {};
  },
  methods: {
    imageClicked(idx) {
      this.$emit("onImageClicked", idx);
    },
  },
  components: {},
  props: {},
  mounted() {},
};
</script>
